var positions = [
  {
    id: 5,
    client_name: "Fresh Supermarket",
    date_modified: new Date("2022-09-05T21:40:20.775Z"),
    name: "Accountant",
    time_to_fill: "25",
    cost_per_hire: 450,
    avg_time_to_hire: 23,
    applications: 23,
    interviews: 13,
    assessments: 7,
    hires: 0,
    turnover_rate: 0.45,
    created_at: "2022-09-04T19:41:40.734689Z",
    conversion_rate: 0.45,
    applicant_source: {
      Referral: 0,
      LinkedIn: 0,
      Indeed: 0,
      Google: 0,
      Monster: 0,
      Facebook: 0,
      ZipRecruiter: 0,
      SimplyHired: 0,
      Snag: 0,
      Craigslist: 0,
      Other: 0,
    },
    vacancies: 1,
    filled: null,
    archived: false,
    client: 6,
  },
  {
    id: 6,
    client_name: "Bob's Bicycles",
    date_modified: new Date("2022-09-05T22:04:01.173Z"),
    name: "Bike Mechanic",
    time_to_fill: "30",
    cost_per_hire: 230,
    avg_time_to_hire: 30,
    applications: 5,
    interviews: 2,
    assessments: 2,
    hires: 0,
    turnover_rate: 0.02,
    created_at: "2022-09-05T22:04:01.173550Z",
    conversion_rate: 0.4,
    applicant_source: {
      Referral: "5",
      LinkedIn: 0,
      Indeed: 0,
      Google: 0,
      Monster: 0,
      Facebook: 0,
      ZipRecruiter: 0,
      SimplyHired: 0,
      Snag: 0,
      Craigslist: 0,
      Other: 0,
    },
    vacancies: 1,
    filled: null,
    archived: false,
    client: 3,
  },
  {
    id: 7,
    client_name: "Bob's Bicycles",
    date_modified: new Date("2022-09-05T22:05:06.298Z"),
    name: "Cashier",
    time_to_fill: "30",
    cost_per_hire: 220,
    avg_time_to_hire: 20,
    applications: 10,
    interviews: 5,
    assessments: 5,
    hires: 1,
    turnover_rate: 0.1,
    created_at: "2022-09-05T22:05:06.298977Z",
    conversion_rate: 0.5,
    applicant_source: {
      Referral: "5",
      LinkedIn: "1",
      Indeed: "1",
      Google: "1",
      Monster: 0,
      Facebook: 0,
      ZipRecruiter: "2",
      SimplyHired: 0,
      Snag: 0,
      Craigslist: 0,
      Other: 0,
    },
    vacancies: 2,
    filled: null,
    archived: false,
    client: 3,
  },
  {
    id: 8,
    client_name: "Tom's Hardware",
    date_modified: new Date("2022-09-05T22:16:16.230Z"),
    name: "Cashier",
    time_to_fill: "35",
    cost_per_hire: 340,
    avg_time_to_hire: 30,
    applications: 12,
    interviews: 6,
    assessments: 6,
    hires: 1,
    turnover_rate: 0.05,
    created_at: "2022-09-05T22:16:16.230118Z",
    conversion_rate: 0.01,
    applicant_source: {
      Referral: "2",
      LinkedIn: 0,
      Indeed: "4",
      Google: "4",
      Monster: 0,
      Facebook: 0,
      ZipRecruiter: 0,
      SimplyHired: 0,
      Snag: 0,
      Craigslist: 0,
      Other: "2",
    },
    vacancies: 2,
    filled: null,
    archived: false,
    client: 4,
  },
  {
    id: 9,
    client_name: "Tom's Hardware",
    date_modified: new Date("2022-09-05T22:17:30.165Z"),
    name: "Stocker",
    time_to_fill: "30",
    cost_per_hire: 360,
    avg_time_to_hire: 25,
    applications: 25,
    interviews: 13,
    assessments: 10,
    hires: 2,
    turnover_rate: 0.03,
    created_at: "2022-09-05T22:17:30.165557Z",
    conversion_rate: 0.01,
    applicant_source: {
      Referral: "5",
      LinkedIn: "5",
      Indeed: null,
      Google: 0,
      Monster: 0,
      Facebook: 0,
      ZipRecruiter: "5",
      SimplyHired: 0,
      Snag: 0,
      Craigslist: "5",
      Other: "5",
    },
    vacancies: 3,
    filled: null,
    archived: false,
    client: 4,
  },
];

var positionsArchived = [];

export { positions, positionsArchived };
